export default __webpack_public_path__ + "static/media/difficulty.75a17048.svg";